import React, { Children, cloneElement, useCallback, useEffect, useState } from 'react';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import { Popup } from '../Popup';
import { useBoolean } from '../utils/useBoolean';
import { block } from '../utils/cn';
import './Tooltip.css';
const b = block('tooltip');
const DEFAULT_PLACEMENT = ['bottom', 'top'];
export const Tooltip = (props) => {
    const { children, content, placement = DEFAULT_PLACEMENT } = props;
    const [anchorElement, setAnchorElement] = useState(null);
    const tooltipVisible = useTooltipVisible(anchorElement, props);
    const child = Children.only(children);
    const childRef = child.ref;
    const elementRef = useCallback((node) => {
        setAnchorElement(node);
        if (isFunction(node)) {
            childRef(node);
        }
        else if (isObject()) {
            childRef.current = node;
        }
    }, [childRef]);
    const renderPopup = () => {
        return (React.createElement(Popup, { className: b(), open: tooltipVisible, placement: placement, anchorRef: { current: anchorElement }, disableEscapeKeyDown: true, disableOutsideClick: true, disableLayer: true },
            React.createElement("div", { className: b('content') }, content)));
    };
    return (React.createElement(React.Fragment, null,
        cloneElement(child, { ref: elementRef }),
        renderPopup()));
};
function useTooltipVisible(anchor, { openDelay, closeDelay }) {
    const anchorHovered = useAnchorHovered(anchor);
    const [tooltipVisible, showTooltip, hideTooltip] = useBoolean(false);
    useEffect(() => {
        let timeout;
        if (anchorHovered && !tooltipVisible)
            timeout = setTimeout(showTooltip, openDelay);
        if (!anchorHovered && tooltipVisible)
            timeout = setTimeout(hideTooltip, closeDelay);
        return () => {
            clearTimeout(timeout);
        };
    }, [anchorHovered]);
    return tooltipVisible;
}
function useAnchorHovered(anchor) {
    const [hovered, setHovered, unsetHovered] = useBoolean(false);
    useEffect(() => {
        if (!anchor)
            return;
        anchor.addEventListener('mouseenter', setHovered);
        anchor.addEventListener('mouseleave', unsetHovered);
        return () => {
            anchor.removeEventListener('mouseenter', setHovered);
            anchor.removeEventListener('mouseleave', unsetHovered);
        };
    }, [anchor, setHovered, unsetHovered]);
    return hovered;
}
